import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Lock, KeyRound, CheckCircle2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/api/admin/reset-password`, {
        token, new_password: newPassword, confirm_password: confirmPassword,
      });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur lors de la reinitialisation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.05)]">
          <div className="text-center mb-8">
            <div className="w-14 h-14 rounded-full bg-[#2C3E30] flex items-center justify-center mx-auto mb-4">
              {done ? <CheckCircle2 className="w-6 h-6 text-[#F2F0E9]" strokeWidth={1.5} /> : <KeyRound className="w-6 h-6 text-[#F2F0E9]" strokeWidth={1.5} />}
            </div>
            <h1 className="font-['Playfair_Display'] text-2xl text-[#2C3E30]">
              {done ? 'Mot de passe modifie' : 'Nouveau mot de passe'}
            </h1>
            <p className="text-[#595959] text-sm mt-1">Le Domaine du Pilat</p>
          </div>

          {done ? (
            <div className="text-center space-y-5" data-testid="reset-success">
              <p className="text-sm text-[#595959]">Votre mot de passe a ete reinitialise. Tous les appareils ont ete deconnectes par securite.</p>
              <Button data-testid="reset-goto-login-btn" onClick={() => navigate('/admin')} className="w-full rounded-full py-6 bg-[#2C3E30] text-[#F2F0E9] hover:bg-[#3a5040]">
                Se connecter
              </Button>
            </div>
          ) : !token ? (
            <p className="text-sm text-[#993333] text-center" data-testid="reset-no-token">
              Lien invalide. Refaites une demande depuis l&apos;ecran de connexion.
            </p>
          ) : (
            <form onSubmit={submit} className="space-y-5" data-testid="reset-password-form">
              <div>
                <label className="text-sm font-medium text-[#1C1C1E] mb-1.5 block">Nouveau mot de passe</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#8A9A5B]" strokeWidth={1.5} />
                  <Input data-testid="reset-new-password-input" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Min. 10 caracteres, lettres + chiffres" className="pl-10 rounded-lg h-11" autoComplete="new-password" autoFocus />
                </div>
              </div>
              <div>
                <label className="text-sm font-medium text-[#1C1C1E] mb-1.5 block">Confirmer le mot de passe</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#8A9A5B]" strokeWidth={1.5} />
                  <Input data-testid="reset-confirm-password-input" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirmation" className="pl-10 rounded-lg h-11" autoComplete="new-password" />
                </div>
              </div>
              {error && <p data-testid="reset-error" className="text-[#993333] text-sm">{error}</p>}
              <Button data-testid="reset-submit-btn" type="submit" disabled={loading || newPassword.length < 10 || !confirmPassword} className="w-full rounded-full py-6 text-base bg-[#2C3E30] text-[#F2F0E9] hover:bg-[#3a5040] font-medium" size="lg">
                {loading ? 'Enregistrement...' : 'Reinitialiser le mot de passe'}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
